module.exports = __webpack_public_path__ + "img/CeeYuu_500x127.e79333d2.png";